import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';

const styles = require('./AdvancedSecurityOptionFull.scss');

export default class AdvancedSecurityOptionFull extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <div className={styles.subscription_text_container}>
                    <div>{strings.options_premium_AdvancedSecurityContent_part1}</div>
                    <div>
                        <a href="https://aka.ms/outlookcomadvancedsecurityfaq" target="_blank">
                            {strings.options_premium_AdvancedSecurityContent_LearnMore}
                        </a>
                    </div>
                    <br />
                    <div>{strings.options_premium_AdvancedSecurityContent_part2}</div>
                </div>
                <div className={styles.subscription_btn_container}>
                    <PrimaryButton
                        text={strings.options_premium_buttonText}
                        data-is-focusable={true}
                        disabled={false}
                        onClick={this.navigateToAdvancedSecurity}
                        className={styles.addNewItemButton}
                    />
                </div>
            </div>
        );
    }

    private navigateToAdvancedSecurity(ev: any) {
        ev.stopPropagation();
        let advancedSecurityUrl = 'https://aka.ms/outlooktfa ';

        logUsage(datapoints.PremiumDashManageSecurity.datapoint.name);
        window.open(advancedSecurityUrl, '_blank');
    }
}
